import React, { useState } from "react";
import PropTypes from "prop-types";
import ChevronRight from "/public/images/icons/chevronRight.svg?react";

export default function ShopParticipantCard({ participant, onClick, totalQuantity }) {
  
  const [active, setActive] = useState(false);

  return (
    <div
      className={`flex flex-col ${
        active ? "border-[#EAAA00]" : "border-[#E3E3E3]"
      } bg-white border rounded-[8px] p-6 relative`}
      onClick={() => {!participant.ParticipantPending ? onClick() : null}}
    >
      <div className={`flex ${!participant.ParticipantPending ? 'cursor-pointer' : ''} flex-row w-full justify-between items-center`}>
        <div className="flex flex-row gap-y-3 gap-x-4 justify-center items-center">
          <img  src={`${participant?.ProfilePicture ? participant.ProfilePicture : '/images/default-avatar.svg'}`} width="62" height="62" className="rounded-full w-[62px] h-[62px] object-cover" />
          <div className="flex flex-col gap-2 justify-center">
            <p className="text-base font-medium text-blackc capitalize">
              {participant?.ParticipantName}
            </p>
            <p className="text-[#727272] font-poppins text-[16px] leading-[26px] capitalize">
              {participant?.MemberSince ? (
                participant?.BandCount === 0 ? (
                  <>No Bands Found</>
                ) : (
                  <>X <span className="">{participant?.BandCount} {participant?.BandCount > 1 ? 'Bands' : 'Band'}</span></>
                )
              ) : (
                <><span className="font-semibold">X {totalQuantity || participant?.Quantity} Pending {totalQuantity || participant?.Quantity > 1 ? 'Bands' : 'Band'}</span></>
              )}
              {totalQuantity > 0 && (
                <>, <span className="font-semibold">X {totalQuantity || participant?.Quantity} Pending {totalQuantity || participant?.Quantity > 1 ? 'Bands' : 'Band'}</span></>
              )}
            </p>
          </div>
        </div>
        <div className="">
          <ChevronRight
            className={` ${
              active ? "fill-[#EAAA00] -rotate-90" : "fill-black"
            } transition-all ${!participant.ParticipantPending ? 'cursor-pointer' : ''}`}
          />
        </div>
      </div>
    </div>
  );
}

ShopParticipantCard.propTypes = {
  participant: PropTypes.object,
  onClick: PropTypes.func,
  isInCart: PropTypes.bool,
};